(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fb-customer-success-v2"] && !window.DesignMode) return;
  try {
    
// Image lightbox
document.querySelectorAll('.fb-lightbox').forEach(function(img) {
  img.addEventListener('click', function() {
    var lightbox = document.createElement('div');
    lightbox.id = 'lightbox';
    lightbox.addEventListener('click', function() {
      lightbox.parentNode.removeChild(lightbox);
    });
    document.body.appendChild(lightbox);
  
    var img = document.createElement('img');
    img.src = this.src;
    lightbox.appendChild(img);

    var infoBox = document.createElement('div');
    infoBox.className = "info-box"
    lightbox.appendChild(infoBox);
    
    var quote = document.createElement('p');
    quote.innerHTML = this.getAttribute("data-quote");
    infoBox.appendChild(quote);
    
    var authorInfo = document.createElement('p');
    authorInfo.innerHTML = this.getAttribute("data-author");
    infoBox.appendChild(authorInfo);
    
    var source = document.createElement('a');
    source.innerHTML = "Source →"
    source.target = "_blank"
    source.href = this.getAttribute("data-source");
    infoBox.appendChild(source);
  });
});

// Autoscroll carousel
var carousel = document.getElementById("customer-success-carousel");
var carousel2 = document.getElementById("customer-success-carousel-2");
var pos = 0;
var pos2 = 0;
var dir = 0.5;
var maxPos = carousel.scrollWidth - carousel.clientWidth;
var maxPos2 = carousel2.scrollWidth - carousel2.clientWidth;

setInterval(function() {
    pos = carousel.scrollLeft;
    pos += dir;
    carousel.scrollLeft = pos;
}, 50);

setInterval(function() {
    pos2 = carousel2.scrollLeft;
    pos2 -= dir;
    carousel2.scrollLeft = pos2;
}, 50);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fb-customer-success-v3"] && !window.DesignMode) return;
  try {
    
// Image lightbox
document.addEventListener('click', function(e) {
  if (e.target.classList.contains('fb-lightbox')) {
    const lightbox = document.createElement('div');
    lightbox.id = 'lightbox';
    lightbox.addEventListener('click', function() {
      this.parentNode.removeChild(this);
    });

    const img = document.createElement('img');
    img.src = e.target.src;
    lightbox.appendChild(img);

    const infoBox = document.createElement('div');
    infoBox.className = "info-box";
    const quote = document.createElement('p');
    quote.innerHTML = e.target.getAttribute("data-quote");
    const authorInfo = document.createElement('p');
    authorInfo.innerHTML = e.target.getAttribute("data-author");
    const source = document.createElement('a');
    source.innerHTML = "Source →";
    source.target = "_blank";
    source.href = e.target.getAttribute("data-source");

    infoBox.append(quote, authorInfo, source);
    lightbox.append(infoBox);
    document.body.appendChild(lightbox);
  }
});

// Autoscroll carousels
const carousels = [
  { element: document.getElementById("customer-success-carousel-1"), direction: 0.5 },
  { element: document.getElementById("customer-success-carousel-2"), direction: -0.5 },
  { element: document.getElementById("customer-success-carousel-3"), direction: 0.5 },
];

setInterval(() => {
  carousels.forEach(carousel => {
    let position = carousel.element.scrollLeft;
    position += carousel.direction;
    carousel.element.scrollLeft = position;
  });
}, 50);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fb-press-v2"] && !window.DesignMode) return;
  try {
    
  const quotes = [
    '"Farmbot makes growing food as easy as playing Farmville"',
    '"FarmBot Genesis applies 3-D printing principles to small-scale farming"',
    '"The plants have grown vigorously and the first radishes are ready to be harvested"',
    '"I bet Mesopotamian farmers didn&apos;t see FarmBot coming"',
    '"FarmBot will 3D print your crops and email when they are ready"',
    '"FarmBot is a merge of technology and traditional agriculture"',
    '"Precision agriculture open and accessible to everyone"'
  ];

  let currentQuoteIndex = 0;
  let logo = document.getElementById('press-logo-' + currentQuoteIndex);

  function changeQuote() {
    const pullQuote = document.getElementById('press-pull-quote');

    // fade out the current quote and de-highlight logo
    pullQuote.style.opacity = 0;
    logo.style.filter = 'brightness(1.15)';

    // wait for the fade out to finish before changing the new quote
    setTimeout(function() {
      // increment the current quote index
      currentQuoteIndex = (currentQuoteIndex + 1) % quotes.length;
      logo = document.getElementById('press-logo-' + currentQuoteIndex);
      // update the text of the pullquote to the next quote in the array
      pullQuote.innerHTML = quotes[currentQuoteIndex];
      // highlight the next logo
      logo.style.filter = 'brightness(0.35)';
      // fade in the new quote
      pullQuote.style.opacity = 1;
    }, 500);
  }

  // change the quote every 4 seconds
  setInterval(changeQuote, 4000);

  } catch(e) { console.error(e); }
})();
})();
